module.exports = __webpack_public_path__ + "img/urth-caffe_0.301ee275.jpg";